<template>
  <v-col 
    :cols="cols" 
    @click="handleClick" 
    :style="isAdminBox || isCorteOrFondo ? 'cursor:pointer;':''"
  >
    <v-hover>
      <template v-slot:default="{ hover }">
        <v-card :flat="!hover" min-height="100" class="mr-1" :elevation="hover ? 24 : null">
          <div class="d-flex flex-no-wrap justify-space-evenly">
            <v-avatar :color="color" class="ma-1" size="95" tile>
              <v-icon v-if="content.iconType === 'mdi'" x-large color="white" class="text-h3"> {{content.icon}} </v-icon>
              <font-awesome-icon v-else-if="content.iconType === 'fa'" :icon="content.icon" class="white--text text-h3"></font-awesome-icon>
            </v-avatar>
            <div>
              <v-card-text v-if="type === 'corte'">
                <div class="text--primary">
                  {{ title }} ( <span>{{ content.hora }}</span> )
                </div>
                <div class="font-weight-bold">
                  ({{ content.count }}º) ${{ montoCorte }}<br />
                  Saldo: ${{ formatDecimal(content.saldo) }}
                </div>
              </v-card-text>
              <v-card-text v-else-if="type === 'fondo'">
                <div class="text--primary">{{ title }} ( <span>{{ content.hora }}</span> )</div>
                <div class="font-weight-bold">${{ formatDecimal(content.monto) }}</div>
              </v-card-text>
              <v-card-text v-else>
                <div class="font-weight-bold">
                  {{ content.cantidad }}
                  <div class="text--primary">{{ title }}</div>
                  ${{ formatDecimal(content.monto) }}
                </div>
              </v-card-text>
            </div>
          </div>
          <v-fade-transition>
            <v-overlay
              :absolute="absolute"
              :opacity="opacity"
              :value="hover && type !== 'cobro' && fondoValidates && userIsAdmin"
            >
              <v-btn :color="overlayBtnColor" rounded>
                <v-icon>{{type == 'salida' ? 'mdi-minus' : type == 'corte' ? 'mdi-calculator':'mdi-plus'}}</v-icon>
              </v-btn>
            </v-overlay>
          </v-fade-transition>
        </v-card>
      </template>
    </v-hover>
  </v-col>
</template>
<script>
import {formatDecimal} from "../../services/utils";
import {mapGetters} from "vuex";
// const { getFondoCaja } = api.services.cajaService; 

export default {
  name: "CajaTopBox",
  props: {
    type: String,
    cols: Number,
    color: String,
    content: Object,
  },
  data(){
    return {
      opacity: .95,
      absolute: true,
      fondo: this.getFondoCaja(),
    };
  },
  computed: {
    ...mapGetters(['user']),
    montoCorte(){
      const {monto} = this.content
      return typeof monto == 'string' ? 
        monto : formatDecimal(monto);
    },
    title() {
      return this.content.titulo.toUpperCase();
    },
    overlayBtnColor(){
      return (this.type == 'salida') ? 'red':
        (this.type == 'entrada') ? 'green': 
        (this.type == 'corte') ? 'purple':'grey';
    },
    fondoValidates(){
      return (this.type != 'fondo' && this.fondo) || 
        this.type != 'fondo' && !this.fondo ||
        this.type == 'fondo' && !this.fondo;
    },
    userIsAdmin(){
      return this.user && this.user.perfil == "Administrador";
    },
    isAdminBox(){
      return this.type !== 'cobro' && this.fondoValidates && this.userIsAdmin;
    },
    isCorteOrFondo(){
      return this.type =='corte' || (this.type == 'fondo' && this.fondoValidates);
    }
  },
  methods: {
    getFondoCaja(){},
    formatDecimal(num){ return formatDecimal(num); },
    handleClick(){
      const isAdminBox = this.type !== 'cobro' && this.fondoValidates && this.userIsAdmin;
      const isCorteOrFondo = this.type =='corte' || (this.type == 'fondo' && this.fondoValidates);
      if(isAdminBox || isCorteOrFondo) 
        this.$emit('box-click', this.type);
    }
  }
};
</script>